document.addEventListener('DOMContentLoaded', () => {
  // Parse the URL parameter
  const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    return decodeURIComponent((results[2] || '').replace(/\+/g, " "));
  };

  // Clean up the string
  const prettify = (str) =>
    str.replace(/(-|^)([^-]?)/g, (_, prep, letter) =>
      (prep ? ' ' : '') + letter.toUpperCase()
    );

  // Add a custom title to the hero banner on /lets-connect/ page
  const addHeroTitle = () => {
    const heroHeading = document.querySelector('.hero-content-text-container h1');
    if (!heroHeading) return;

    const title = getParameterByName('hero_title');
    const utm = getParameterByName('utm_campaign');
    const text = title || utm;

    if (text) {
      heroHeading.insertAdjacentText('beforeend', ' on ' + prettify(text));
    }
  };

  // Pop out harmony-calculator based on the anchor in the URL
  const triggerModalIfHash = () => {
    if (window.location.hash === '#harmony-calculator') {
      const modalEl = document.getElementById('harmony-calculator');
      if (modalEl && typeof bootstrap !== 'undefined') {
        new bootstrap.Modal(modalEl).show();
      }
    }
  };

  if (document.querySelector('.page-id-18945')) addHeroTitle();
  if (document.querySelector('.postid-33377')) triggerModalIfHash();
});